import {number_format} from "./common-new";
import {$body, $document} from "./globals";
import {imageLazyLoad} from "./lazyload";
import {frontendAndBackendFunctions} from "./common-new";

export class GroupFilter {
    static instance = null;
    #LoadByAjax = true;
    #disableAjax = false;
    #$filter = null;
    #$products = null;
    #cancel = null;
    #popstate = false;
    #iniciator = null;

    constructor($products, $filter) {
        if (GroupFilter.instance) {
            return GroupFilter.instance;
        }
        this.#$filter = $filter;
        this.#$products = $products;
        if (window.innerWidth <= 991) {
            this.#$filter.find('.c-filters__category-wrapper').removeClass('c-filters__category-wrapper--is-open').find('.c-filters__category-header').removeClass('.c-filters__category-header--is-open').next().hide();
        }
        const _ = this;
        $document.on('click', '.removeFilter', function () {
            _.#cancel = $(this).attr('data-jquery');
            _.#$filter.find('input[type=submit][name=apply]').trigger('click');
            _.#cancel = null;
        });
        this.#attachEvents();
        GroupFilter.#uiPriceSlider();
    }

    #attachEvents() {
        const _ = this;
        _.#popstate = false;
        //aby se to neposilalo ajaxem, ale normalne refresla cela stranka...
        _.#$filter.find('button[name=cancel]').on('click', function () {
            _.#disableAjax = true;
        });
        //pri posilani, tak aby se neposilal to talcitko cancelu...
        _.#$filter.find('input[name=apply]').on('click', function (e, popstate, iniciator) {
            iniciator ? _.#iniciator = iniciator : _.#iniciator = null;
            popstate ? _.#popstate = true : _.#popstate = false;
            _.#$filter.find('button[name=cancel]').attr('disabled', 'disabled');
        });
        window.onpopstate = function (e) {
            _.#$filter.find('form').attr('action', e.originalTarget.location.href);
            _.#$filter.find('input[type=submit][name=apply]').trigger('click', [true]);
        };
        if (_.#LoadByAjax) {
            _.#setOnSubmitEvent();
        }
    }

    #setOnSubmitEvent() {
        const _ = this;
        _.#$filter.find('form').submit(function (e) {
            if (_.#disableAjax) return;
            const form = $(this);
            e.preventDefault();
            const inputAlabels = form.find('input,label');
            inputAlabels.addClass('disabled');
            inputAlabels.on('keydown click dragstart drop focus', function (e) {
                e.preventDefault();
            });
            const opened = {};
            if (window.innerWidth > 991) {
                $('.c-filters__category-header.c-filters__category-header--is-open').each(function () {
                    opened[this.getAttribute('data-opener-id')] = true;
                });
            }
            const data = form.serializeArray();
            data.push({name: 'openedFilters', value: JSON.stringify(opened)})
            data.push({name: 'isMobile', value: window.innerWidth <= 991})
            GroupFilter.showLoading();
            $.ajax({
                type: "POST",
                url: form.attr('action') + ((_.#cancel) ? '&unsetFilter' + _.#cancel + '=1' : '') + (_.#popstate ? '&justUrl=1' : '') + (_.#iniciator ? '&iniciator=' + _.#iniciator : ''),
                data: $.param(data),
                dataType: 'json',
                success: function (data) {
                    _.#iniciator = null;
                    _.#$filter.find('button[name=cancel]').removeAttr('disabled');
                    const $newProducts = $(data.html);
                    if (typeof data.canonicalUrl != "undefined") {
                        resolveCanonical(data.canonicalUrl);
                    }
                    if (typeof data.title != 'undefined') {
                        resolveTitle(data.meta_title, data.title);
                    }
                    if (typeof data.filter != 'undefined') {
                        const $newFilter = $(data.filter);
                        _.#$filter.replaceWith($newFilter);
                        _.#$filter = $newFilter;

                        _.#attachEvents();
                    } else {
                        _.#popstate = false;
                    }

                    if (typeof data.url != 'undefined') {
                        window.history.pushState('', '', data.url);
                    }
                    if (typeof data.sorting != 'undefined') {
                        $('.c-catalog__filter-row').html($(data.sorting).html());
                    }
                    if('GA' in data){
                        gtag("event", "view_item_list", {
                            send_to: GA4,
                            ...data.GA
                        });
                        gtag("event", "view_item_list", {
                            send_to: GADS,
                            ...data.GA
                        });
                    }
                    _.#$products.replaceWith($newProducts);
                    $('html, body').animate({
                        scrollTop: $('#catalog-wrap').offset().top
                    }, 150, function () {
                        imageLazyLoad();
                    });
                    _.#$products = $newProducts;
                    GroupFilter.removeLoading();
                    frontendAndBackendFunctions();
                }
            });
        });
        /*_.#$filter.on('change', 'input[type=checkbox]', function (e) {
            e.preventDefault();
            _.#$filter.find('input[type=submit][name=apply]').trigger('click', [false, $(this).closest('.c-filters__category-wrapper').attr('data-category-wrapper-id')]);
        });*/
    }

    static showLoading() {
        const loading = $('.c-catalog__loading');
        if (!loading.length) {
            $body.append('<div class="c-catalog__loading"/>');
        }
    }

    static removeLoading() {
        $(".c-catalog__loading").remove();
        GroupFilter.#uiPriceSlider();
    }

    static #uiPriceSlider() {
        const sliders = $('.noUiSlider');
        if (sliders.length) {
            Promise.all([import("nouislider/dist/nouislider.mjs"), import("wnumb"), import("nouislider/dist/nouislider.min.css")])
                .then(([noUiSlider, wnumb]) => {
                    sliders.each(function () {
                        const slider = $(this).append('<div class="noUiSliderContainer"></div>');
                        const max = slider.parent().find('.present-value.max');
                        const min = slider.parent().find('.present-value.min');
                        const currency = slider.find('input.currency').val();
                        const sliderContainer = slider.find('.noUiSliderContainer').get(0);
                        if (!("noUiSlider" in sliderContainer)) {
                            noUiSlider.create(sliderContainer, {
                                start: [parseFloat(slider.data('start-min')), parseFloat(slider.data('start-max'))],
                                step: parseFloat(slider.data('step')),
                                connect: true,
                                tooltips: false,
                                range: {
                                    'min': parseFloat(slider.data('range-min')),
                                    'max': parseFloat(slider.data('range-max'))
                                },
                                format: wnumb.default({
                                    decimals: 0
                                })
                            });

                            sliderContainer.noUiSlider.on('change', function (values) {
                                slider.find('.min_input').val(values[0]);
                                slider.find('.max_input').val(values[1]);
                                //slider.closest('form').find('input[type=submit][name=apply]').trigger('click', [false, slider.closest('.c-filters__category-wrapper').attr('data-category-wrapper-id')]);
                            });
                            if (currency && min.length && max.length) {
                                sliderContainer.noUiSlider.on('update', function (values) {
                                    min.html(number_format(values[0], 0, '.', ' ') + ',- ' + currency);
                                    max.html(number_format(values[1], 0, '.', ' ') + ',- ' + currency);
                                });
                            }
                        }
                    });
                })
        }
    }
}

export const resolveCanonical = (data) => {
    const types = ['canonical', 'prev', 'next'];
    for (let i = 0; i < types.length; i++) {
        const link = $(`link[rel="${types[i]}"]`);
        if (typeof data[types[i]] != "undefined") {
            if (link.length) {
                link.replaceWith(data[types[i]]);
            } else {
                $('head').append(data[types[i]]);
            }
        } else {
            link.remove();
        }
    }
}

export const resolveTitle = (metatitle, h1) => {
    document.title = metatitle;
    $('.jumbotron h1').text(h1);
}